import { ToastProps } from './Toast';
import { toastEvent } from './ToastContainer';

export const AddToastEvent = 'addToast';

export const toast = ({ position = 'top-right', ...restArgs }: ToastProps) => {
  toastEvent.emit(AddToastEvent, { ...restArgs, position });
};
